'use strict';

/**
 * Init upsell feature events on PDP & minicart
 */
function upsellEvents() {
    $('body').on('click', '.js-add-to-cart-upsell', function (e) {
        e.preventDefault();
        let addToCartUrl = $('.add-to-cart-url').val();
        let $this = $(this);

        if (!addToCartUrl) {
            return;
        }

        var $rxb2cModal = $('#rxB2CAddToCartModal');
        if ($rxb2cModal.length && $('input[name="currentCartIsRX"]', $rxb2cModal).val() === 'true' && $('input[name="customerConfirmSubmit"]', $rxb2cModal).val() !== 'true') {
            $('body').trigger('rxb2c:openconfirmationmodal', {
                actionTarget: $this
            });
            return;
        }

        $.ajax({
            method: 'post',
            url: addToCartUrl,
            data: {
                quantity: $(this).attr('data-upsell-qty') || 1,
                pid: $(this).attr('data-upsell-pid')
            },
            success: function (data) {
                if (!data.error) {
                    $('.minicart').trigger('count:update', data);
                    $('body').trigger('cart:update');
                }
            }
        });
    });
}

module.exports = {
    upsellEvents: upsellEvents
};
